import React from "react";
import "../styles/Loader.css";

function Loader({
  message = "Yükleniyor...",
  size = "md",
  variant = "section",
  className = "",
}) {
  const sizeClass = size === "sm" ? "loader-sm" : size === "lg" ? "loader-lg" : "";
  const wrapperClassName = [
    "loader-wrapper",
    `loader-wrapper-${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      <div className={`loader ${sizeClass}`} role="status" aria-live="polite" aria-label={message || "Yükleniyor"}>
        <div className="form1">
          <div className="square" />
          <div className="square" />
        </div>
        <div className="form2">
          <div className="square" />
          <div className="square" />
        </div>
      </div>
      {message ? <p className="loader-message">{message}</p> : null}
    </div>
  );
}

export default Loader;
